



















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { LinkedAccountApi } from "@/shared/types";
import LinkedAccountsListElement from "./LinkedAccountsListElement.vue";
import { useBankAccountStore } from "@/employee/store/bankAccount";

@Component({
  components: {
    LinkedAccountsListElement
  }
})
export default class LinkedAccountsList extends Vue {
  isEditing = false;

  @Prop()
  disabled: boolean;

  bankAccountStore = useBankAccountStore();


  get checkingAccounts (): LinkedAccountApi[] {
    return this.bankAccountStore.linkedAccounts.filter(a => a.linkedBankAccountType === "checking");
  }

  get savingsAccounts (): LinkedAccountApi[] {
    return this.bankAccountStore.linkedAccounts.filter(a => a.linkedBankAccountType === "savings");
  }

  get buttonsAreDisabled () {
    return this.isEditing || this.disabled;
  }

  onEditButtonClicked (isEditing: boolean) {
    this.isEditing = isEditing;
  }
}
